import React from 'react';

const ChickenDashboardContext = React.createContext({
  distReqParams: null,
  intervalReqParams: null,
  availReqParams: null,
});

export default ChickenDashboardContext;
